import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  node: {
    backgroundColor: 'silver',
    borderRadius: '50%',
    width: 15,
    height: 15,
    position: 'absolute'
  },
})


class Node extends Component {
  render () {
    const { last } = this.props
    const lastStyles = last ? { position: 'absolute', bottom: 0 } : {}
    return <div className={this.props.classes.node} style={lastStyles} />
  }
}

export default withStyles(styles)(Node)



// WEBPACK FOOTER //
// ./src/components/Timeline/Node.js